
<script>
    import MediaInput from '../../common/Media/MediaInput.svelte';
    import Thumbnail from '../../common/Media/Thumbnail.svelte';
    import Marker from '../../common/Media/Marker.svelte';
    import FileUpload from '../../common/FileUpload.svelte';
    import ConfirmationModal from '../../ConfirmationModal.svelte';
    import Modal from '../../Modal.svelte';
    import {sgettext} from '../../../i18n.js';
    import Button from '../../Button.svelte';

    export let id = 'mediaLibraryModal';
    export let title = 'Media Library';
    export let list = [];
    export let uploadApi = '';
    export let thumbnailComponent = Thumbnail;
    export let handleDelete = () => {};
    export let cancelDelete = () => {toggleDeleteModal('hide')};
    export let handleThumbnailClick = () => {};
    export let deleteConfirmationId = 'deleteConfirmationModal';

    let errors = [];
    let selectedItem = null;
    let deleting = false;

    function handleUploaded(file){
        list = [...list, file];
    }

    function handleErrors(error) {
      errors = [...errors, error];
      setTimeout(() => errors = [], 6000)
    }

    function handleInvalidFile(event) {
        const error = `${event.detail.fileName} ${sgettext('$$FAILED_UPLOAD$$')}, ${event.detail.extension} ${sgettext('$$UNSUPPORTED_TYPE$$')}.`
        handleErrors(error);
    }

    function closeLibraryModal(){
        jQuery(`#${id}`).modal('hide');
    }

    function getSelectedMedia(id){
        const filtered = list.filter(l => l.id === id);
        let item = null;

        if(filtered.length){
            item = filtered[0];
        }

        return item;
    }

    function onDeleteClicked(id){
        selectedItem = getSelectedMedia(id);
        toggleDeleteModal('show');
    }

    function toggleDeleteModal(state){
        jQuery(`#${deleteConfirmationId}`).modal(state);
    }

    async function onDeleteConfirmed() {
        deleting = true;
        const resp = await handleDelete(selectedItem.id);

        if(resp.ok){
            list = list.filter(l => l.id !== selectedItem.id);
        } else {
          resp.json().then(response => handleErrors(response.message))
        }
        selectedItem = null;
        toggleDeleteModal('hide');
        deleting = false;
    }

</script>

<style>
    .gallery {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
        grid-gap: 30px;
        justify-items: center;
    }
</style>

<Modal
    {id}
    title={sgettext(title)}
    extraLarge={true}
    backdrop={'static'}>

    <div slot="body" class="element-media-container">
        <div class="gallery">
        {#each list as media}
            <svelte:component
                this={thumbnailComponent}
                id={media.id}
                url={media.thumbnail}
                media={media.url}
                type={media.type}
                handleDelete={onDeleteClicked}
                handleClick={handleThumbnailClick}
            />
        {/each}
        </div>
        {#if uploadApi}
        <FileUpload {uploadApi} onUploaded={handleUploaded} on:invalidFile={handleInvalidFile}/>
        {/if}

        {#if errors}
            <div class="text-danger text-center mt-2">
                {#each errors as error}
                    <h5 class="mb-1">{error}</h5>
                {/each}
            </div>
        {/if}
    </div>
    <div slot="footer" class="footer">
        <Button
            type="primary"
            on:click={closeLibraryModal}
            name={sgettext("$$CANCEL$$")} />
    </div>
</Modal>

<ConfirmationModal
    id={deleteConfirmationId}
    title="{sgettext('$$DELETE_CONFIRMATION$$')}"
    onYes={onDeleteConfirmed}
    onNo={cancelDelete}
    sending={deleting}>
    <div slot="message">
        <p>{sgettext('$$SURE_WANT_DELETE_MEDIA_1$$')}</p>
        {#if selectedItem}
        <Thumbnail
            url={selectedItem.thumbnail}
            media={selectedItem.url}
            type={selectedItem.type}
        />
        {/if}
        <br/>
    </div>
</ConfirmationModal>
